import React from 'react';

/**
 * Focuses the returned element once, when the component owning it mounts.
 * Deferred to the next macrotask like `useFocusCountField`, so it lands after
 * react-aria's own dialog focus management has settled for the same render.
 */
export const useFocusOnArrival = <
    T extends HTMLElement,
>(): React.RefObject<T | null> => {
    const ref = React.useRef<T>(null);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            ref.current?.focus();
        }, 0);
        return () => clearTimeout(timeout);
    }, []);

    return ref;
};
